/**
 * @file 玉门关
 * @author zhaolongfei
 * @wiki https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/b_dB7xLNHi/cuv64FB8Ez/eq4KoU5lPxs_OL
 */

// @ts-ignore
import {ParisFactory} from '@baidu/paris';
import {sendYaLog} from '@lib/log';

// 渠道号，由管理员分配
const sid = '2124';

class Paris {
    constructor() {
        // 加载后请立即初始化配置
        ParisFactory.create({
            sid,
            timeout: 200, // CDN的请求超时时间
            abcliteUrl: `https://dlswbr.baidu.com/heicha/mw/abclite-${sid}-s.js`,
            acsUrl: `https://dlswbr.baidu.com/heicha/mm/${sid}/acs-${sid}.js`,
            // 容灾配置
            disasterConfig: {
                // 备用CDN地址
                acsUrl: `https://miaowu.baidu.com/sdk/heicha/mm/${sid}/acs-${sid}.js`,
                // 备用CDN地址
                abcliteUrl: `https://miaowu.baidu.com/sdk/heicha/mw/abclite-${sid}-s.js`,
                // 主服务器上报失败后的备用上报地址
                secondReportUrl: 'https://miaowu.baidu.com/slim/abdr',
            },
        });
    }

    // 获取签名
    getAcsToken() {
        return new Promise(resolve => {
            let done = false;
            // @ts-ignore
            const parisInstance = window[`paris_${sid}`];

            // 必须保证在 ParisFactory.create 同时传入 acsUrl 与 abcliteUrl
            parisInstance.getAcsTokenWithAbcliteActiveReport({
                subid: '', // 业务场景的子渠道号
            }, (acsTokenOrErrorCode: string) => {
                sendYaLog(`get_acs_token_${acsTokenOrErrorCode}`);
                if (done) {
                    return;
                }
                done = true;
                resolve(acsTokenOrErrorCode);
            });

            // 200ms 超时
            setTimeout(() => {
                if (!done) {
                    done = true;
                    sendYaLog('get_acs_token_timeout', 'net');
                    resolve('');
                }
            }, 200);
        });
    }
}

const paris = new Paris();

export default paris;
